module.exports = __webpack_public_path__ + "img/Notification.3b207d13.svg";